import React from 'react';
import { profileStatus } from '../../utils/crossBorder';

const TONE = {
  ok:   'bg-tone-ok text-tone-ok-ink border-tone-ok-line',
  warn: 'bg-tone-warn text-tone-warn-ink border-tone-warn-line',
  info: 'bg-tone-info text-tone-info-ink border-tone-info-line',
};

/**
 * A scheme profile's status as a small badge: Sandbox reference, Provisional,
 * Reviewed or Pinned, with what that means on hover. The tones are theme
 * tokens, so it reads in the portal and in the console, light or dark.
 */
export default function ProfileStatusBadge({ status, className = '' }) {
  const s = profileStatus(status);
  return (
    <span title={s.note}
      className={`text-xs font-medium px-2 py-0.5 rounded-full border whitespace-nowrap ${
        TONE[s.tone] ?? 'bg-gray-100 text-gray-700 border-gray-200'} ${className}`}>
      {s.label}
    </span>
  );
}
